export default "__VITE_ASSET__Dt33JqNb__"